import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import axios, { type AxiosError } from "axios";

interface UploadBadgeVerificationPhotoParams {
  uploadUrl: string;
  photoBlob: Blob;
}

/**
 * Hook to upload a badge verification photo to S3 using a presigned URL.
 *
 * @returns A mutation that uploads a photo blob to the provided presigned S3 URL
 */
export function useUploadBadgeVerificationPhoto(
  options: UseMutationOptions<void, AxiosError, UploadBadgeVerificationPhotoParams> = {}
) {
  return useMutation({
    mutationFn: async ({ uploadUrl, photoBlob }: UploadBadgeVerificationPhotoParams) => {
      // Use axios directly to avoid our API client's Authorization header
      await axios.put(uploadUrl, photoBlob, {
        headers: {
          // Blob.type is set from the data URL MIME type when created via base64ToBlob
          "Content-Type": photoBlob.type,
        },
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.BADGE_VERIFICATION_S3_UPLOAD_FAILURE,
    },
    ...options,
  });
}
